





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Industries from '@/components/Industries/Industries.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyIndustrySettings',
  	components: { Industries, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getIndustries();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingIndustries;
  	}
}
